/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2016, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./FilterBaseView',
	'../../widgets/livewidget/nls/StringResources'
],
function(View, StringResources) {
	'use strict';

	var RangeFilterView = View.extend({
		reactViewClass: 'NumericFilter', // This name is used in css. If ever change, update filterControl css file
		compactReactViewClass: 'CompactNumericFilter', // This name is used in css. If ever change, update filterControl css file

		init: function() {
			RangeFilterView.inherited('init', this, arguments);
		},

		_getCommonViewProps: function() {
			var currentValues = this.model.toJSON();
			var props = {
				title: currentValues.name,
				actionTitle: StringResources.get('filter'),
				minimumValue: currentValues.min,
				maximumValue: currentValues.max,
				fromValue: currentValues.from,
				toValue: currentValues.to,
				inverted: currentValues.inverted,
				// should come from data type?
				decimalPlaces: (this.options.decimalPlaces || 0),
				filterSelectionType: 'range',
				locale: this.locale,
				totalValues: 2,
				allowSwitch: false,
				allowIncludeNulls: false,
				loading: this.loading
			};
			return props;
		},

		_getCommonViewCallbacks: function() {
			return {
				onClear: this._onClear.bind(this),
				onChange: this._onChange.bind(this),
				onClick: this._onClick.bind(this), // not applicable to RangeFiler
				onSearch: this._onSearch.bind(this), // not applicable to RangeFiler
				onApply: this._onApply.bind(this),
				onDone: this._onDone.bind(this),
				onClose: this._onClose.bind(this) // not applicable to compact mode
				// getValue: this._getValue.bind(this) // not applicable to RangeFiler
			};
		}

	});
	return RangeFilterView;
});
